"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Atributo = void 0;
var Atributo = /** @class */ (function () {
    function Atributo(identificador, valor, fila, columna) {
        this.identificador = identificador;
        this.valor = valor;
        this.linea = fila;
        this.columna = columna;
    }
    return Atributo;
}());
exports.Atributo = Atributo;
